import { render, staticRenderFns } from "./RecentLeaveRequest.vue?vue&type=template&id=31e91422"
import script from "./RecentLeaveRequest.vue?vue&type=script&lang=js"
export * from "./RecentLeaveRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports